<template>
  <div class="cx-editor">
    <!-- <div id="header">
      <img @click="clickBtn" src="../assets/img/logo.svg">
      <div>
        <el-button @click="saveContent('draft')">保存草稿</el-button>
        <el-button type="primary" @click="saveContent('publish')">发布</el-button>
      </div>
    </div> -->
    <div id="toolbar">
      <span v-for="(toolGroup, index) in toolbar" :key="index" class="tool-group">
        <a v-for="item in toolGroup" :key="item.id">
          <!-- <el-dropdown trigger="click" v-if="['heading'].includes(item.id)" @command="selectHeadOption"> -->
          <el-dropdown trigger="click" v-if="['heading'].includes(item.id)" @command="selectHeadOption">
            <a class="tool-btn" :id="item.id">
              <span>
                <span class="tool-btn-icon" :style="`background-image:url(${require(`../assets/img/toolbar/${item.icon}`)});background-position: center;`">
                </span>
                <span class="tool-btn-name">{{item.name}}</span>
              </span>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(option,index) in headingOptions" :key="option.model" :command="option.model" :class="option.class" :style='`font-size:${23 - index * 4}px`'>{{option.title}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" v-else-if="['fontSize'].includes(item.id)" @command="selectFontSizeOption">
            <a class="tool-btn" :id="item.id">
              <span>
                <span class="tool-btn-icon" :style="`background-image:url(${require(`../assets/img/toolbar/${item.icon}`)});background-position: center;`">
                </span>
                <span class="tool-btn-name">{{item.name}}</span>
              </span>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="option in fontSizeOptions" :key="option" :command="option" :class="`cx-fontsize_${option}px`">{{option}}px</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" v-else-if="['alignment'].includes(item.id)" @command="selectAlignmentOption">
            <a class="tool-btn" :id="item.id">
              <span>
                <span class="tool-btn-icon" :style="`background-image:url(${require(`../assets/img/toolbar/${item.icon}`)});background-position: center;`">
                </span>
                <span class="tool-btn-name">{{item.name}}</span>
              </span>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="option in alignmentOptions" :key="option.name" :command="option.name" :class="option.className" :icon="`${option.className}_icon`">{{option.title}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <a class="tool-btn" v-else-if="['fontColor'].includes(item.id)" :id="item.id" @click="clickFontColor" @mousedown=" evt => evt.preventDefault() ">
            <span>
              <span class="tool-btn-icon" :style="`background-image:url(${require(`../assets/img/toolbar/${item.icon}`)});background-position: center;`">
              </span>
              <span class="tool-btn-name">{{item.name}}</span>
              <el-color-picker
                v-model="color"
                show-alpha
                :predefine="predefineColors"
                @change="selectFontColor">
              </el-color-picker>
            </span>
          </a>
          <el-dropdown trigger="click" v-else-if="['listType'].includes(item.id)" @command="selecListOption">
            <a class="tool-btn" :id="item.id">
              <span>
                <span class="tool-btn-icon" :style="`background-image:url(${require(`../assets/img/toolbar/${item.icon}`)});background-position: center;`">
                </span>
                <span class="tool-btn-name">{{item.name}}</span>
              </span>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="option in listTypeOptions" :key="option.name" :command="option.name" :class="option.className" :icon="`${option.className}_icon`">{{option.title}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <a class="tool-btn" v-else :id="item.id" @click="handleClickToolBtn(item.id)" @mousedown="evt => evt.preventDefault() ">
            <span>
              <span class="tool-btn-icon" :style="`background-image:url(${require(`../assets/img/toolbar/${item.icon}`)});background-position: center;`">
              </span>
              <span class="tool-btn-name">{{item.name}}</span>
            </span>
          </a>
        </a>
      </span>
    </div>
    <div id="title">
      <textarea autocomplete="off" id="txtTitle" placeholder="请输入标题" maxlength="100" style="resize: none; min-height: 32px;" v-model="title"></textarea>
    </div>
    <div id="content">
    </div>
    <el-dialog :visible.sync="dialogImageVisible" :show-close="false">
      <p class="header-tab">
        <a :class="{active: isActive}" @click="handleSwitchTab">上传图片</a>
        <a :class="{active: !isActive}" @click="handleSwitchTab">链接添加</a>
      </p>
      <div class="content-div" v-if="isActive" v-loading="insertImageLoading">
        <!-- accept=".jpeg,.jpg,.png,.gif" -->
        <el-upload
          class="content-upload-img"
          ref="contentUploadImg"
          action=""
          accept="image/*"
          :on-change="handleFileChange"
          :auto-upload="false"
        >
          <el-button slot="trigger" size="small" type="primary"
            >选择图片</el-button
          >
        </el-upload>
        <p>
          支持上传jpg、gif、png等多种格式，单张图片不超过5MB
        </p>
      </div>
      <div class="content-div" v-else>
        <div class="input-link-div">
          <el-input v-model="imageLink" class="image-link" placeholder="输入图片URL"></el-input>
          <el-button type="primary" @click="insertImageLink">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogAbstractVisible" :show-close="false" 
    :close-on-press-escape="false" :close-on-click-modal="false">
      <p class="header-tab">生成摘要</p>
      <div class="abstract-content-div">
        <el-input v-model="abstractContent" type="textarea" class="abstract-textarea"></el-input>
        <div class="abstract-footer">
          <el-button @click="cancelAbstract">取消</el-button>
          <el-button type="primary" @click="createAbstract">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="config-view">
      <div class="picture">
        <span class="left-title">配图：</span>
        <el-upload
          class="page-upload-img"
          ref="pageUploadImg"
          action=""
          accept="image/*"
          :on-change="handlePageImgChange"
          :auto-upload="false"
        >
          <span class="image" v-loading='pageImgLoading'> + </span>
        </el-upload>
      </div>
      <div class="tags">
        <span class="left-title">话题：</span>
        <el-tag
          v-for="tag in tags"
          :key="tag.name"
          closable
          @close="handleClose(tag)">
          {{tag.name}}
        </el-tag>
        <el-popover
          placement="right"
          width="200"
          trigger="click">
          <el-autocomplete
            v-model="state"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入话题搜索"
            @select="handleSelect"
          ></el-autocomplete>
          <span slot="reference" class="add-tag-btn">添加话题</span>
        </el-popover>
      </div>
      <div class="category">
        <span class="left-title">个人分类：</span>
        <!-- :closable="!isAdmin" -->
        <el-tag
          v-for="tag in categorys"
          :key="tag.name"
          :closable="true"
          @close="handleCloseCategorys(tag)">
          {{tag.name}}
        </el-tag>
        <!-- :disabled="isAdmin" -->
        <el-popover
          placement="right"
          width="150"
          trigger="click"
          >
          <p v-if="isAdmin && categorysList.length == 0">该博主没有设置分类</p>
          <p v-else-if="categorysList.length == 0" v-loading="categorysLoading">还没有设置分类，去<span style="color:#4990E1" @click="setUpCategotys">设置</span></p>
          <el-checkbox-group v-else v-loading="categorysLoading" v-model="checkCategorysList" @change="handleChangeCategorys">
            <el-checkbox v-for="item in categorysList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
          </el-checkbox-group>
          <span slot="reference" class="add-tag-btn" @click="addCategorys">添加分类</span>
        </el-popover>
      </div>
      <div class="other">
        <span class="left-title">其它设置：</span>
        <el-checkbox v-model="copyStatus">不允许复制</el-checkbox>
        <el-checkbox v-model="commentStatus">不允许评论</el-checkbox>
        <el-checkbox v-if="isAdmin" v-model="mainStatus">显示在博客首页</el-checkbox>
      </div>
    </div>
    <div class="config-view" v-if="isAdmin">
      <div class="publish-time">
        <span class="left-title">发布时间：</span>
        <el-date-picker
          v-model="publishTime"
          value-format="timestamp"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div class="author">
        <span class="left-title">作者：</span>
        <el-autocomplete
            v-model="author"
            :fetch-suggestions="querySearchAsyncAuthor"
            :trigger-on-focus="false"
            placeholder="请输入作者搜索"
            @select="handleSelectAuthor"
          ></el-autocomplete>
      </div>
      <div class="audio">
        <span class="left-title">AI语音：</span>
        <el-radio v-model="audioStatus" label="1">无语音</el-radio>
        <el-radio v-model="audioStatus" label="2">生成语音</el-radio>
        <el-button v-if="currId && audioStatus == 2" type="primary" round @click="generateVoice" v-loading="generateVoiceBtnLoading">重新生成语音</el-button>
      </div>
      <div class="audio-adress">
        <span class="left-title">语音地址：</span>
        <div class="right-block" v-if="audioStatus == '2' && this.currId">
          <!-- <span v-if="meta.male_speech" @click="jumpAudio(meta.male_speech)">男声正式</span><br>
          <span v-if="meta.female_speech" @click="jumpAudio(meta.female_speech)">女声正式</span><br>
          <span v-if="meta.male_probation"  @click="jumpAudio(meta.male_probation)">男声试读</span><br>
          <span v-if="meta.female_probation"  @click="jumpAudio(meta.female_probation)">女声试读</span> -->
          <span @click="jumpAudio('male_speech')">男声正式: {{meta.male_speech ? meta.male_speech : '语音生成中请稍后刷新页面查看。'}}</span><br>
          <span @click="jumpAudio('female_speech')">女声正式: {{meta.female_speech}}</span><br>
        </div>
        
      </div>
    </div>

  </div>
</template>
<script>

import $ from 'jquery'
// import CKEditorInspector from '@ckeditor/ckeditor5-inspector';
import CaiXinEditor from '../blogEditor/Editor/CaiXinEditor'
import {Essentials} from '@ckeditor/ckeditor5-essentials'
import {Paragraph} from '@ckeditor/ckeditor5-paragraph'
import {Heading} from '@ckeditor/ckeditor5-heading'
import {Bold} from '@ckeditor/ckeditor5-basic-styles'
import {Italic} from '@ckeditor/ckeditor5-basic-styles'
import {List} from '@ckeditor/ckeditor5-list'
import {Link} from '@ckeditor/ckeditor5-link'
// import {Image, ImageToolbar, ImageStyle, ImageResizeEditing, ImageResizeHandles} from '@ckeditor/ckeditor5-image'
import {Image, ImageToolbar, ImageStyle} from '@ckeditor/ckeditor5-image'
import {FontSize, FontColor} from '@ckeditor/ckeditor5-font'
import {Alignment} from '@ckeditor/ckeditor5-alignment'
import {formatHtml} from '../blogEditor/Editor/sourceEditing/formathtml'
import createElement from '../blogEditor/Editor/sourceEditing/createelement'
import ElementReplacer from '../blogEditor/Editor/sourceEditing/elementreplacer'
import GeneralHtmlSupport from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport'
// import HtmlComment from '@ckeditor/ckeditor5-html-support/src/htmlcomment'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
// import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat';
// import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';



import { BlogApi } from '../utils/api/blog.api'
import { environment } from '../environment'
import { isMobile } from '../utils/utils'


const COMMAND_FORCE_DISABLE_ID = 'SourceEditingMode';

export default {
  name: 'RichTextEditor',
  data() {
    return {
      isAdmin: false,
      isFilter: false,
      authorHomeUrl: '',
      currId: null,
      title: '',
      brief: '',
      toolbar: [
        [
          { 
            id: 'undo',
            name: '撤销',
            icon: 'undo.svg',
          },
          { 
            id: 'redo',
            name: '重做',
            icon: 'redo.svg',
          },
        ],
        [
          { 
            id: 'heading',
            name: '标题',
            icon: 'head.svg',
          },
          { 
            id: 'fontSize',
            name: '字号',
            icon: 'fontSize.svg',
          },
          // { 
          //   id: 'fontColor',
          //   name: '颜色',
          //   icon: 'btn.svg',
          // },
          { 
            id: 'bold',
            name: '加粗',
            icon: 'bold.svg',
          },
          { 
            id: 'italic',
            name: '斜体',
            icon: 'italic.svg',
          },
          { 
            id: 'alignment',
            name: '对齐',
            icon: 'alignment.svg',
          },
        ],
        [
          { 
            id: 'image',
            name: '图像',
            icon: 'image.svg',
          },
          { 
            id: 'link',
            name: '链接',
            icon: 'link.svg',
          }
        ],
        [
          { 
            id: 'listType',
            name: '列表',
            icon: 'listType.svg',
          },
          { 
            id: 'abstract',
            name: '摘要',
            icon: 'abstract.svg',
          },
          // { 
          //   id: 'catalog',
          //   name: '生成目录',
          //   icon: 'catalog.svg',
          // }
        ],
        [
          { 
            id: 'sourceCode',
            name: '源代码',
            icon: 'sourceCode.svg',
          },
          { 
            id: 'sourceCodeFilter',
            name: '清除样式',
            icon: 'filterCode.svg',
          }
        ]
      ],
      headingOptions: [
        {
          class: "cx-heading_heading1",
          model: "heading1",
          title: "H₁",
          view: "h1",
        },
        {
          class: "cx-heading_heading2",
          model: "heading2",
          title: "H₂",
          view: "h2",
        },
        {
          class: "cx-heading_heading3",
          model: "heading3",
          title: "H₃",
          view: "h3",
        },
        {
          class: "cx-heading_heading4",
          model: "heading4",
          title: "H₄",
          view: "h4",
        }
      ],
      fontSizeOptions: [12,14,16,18,20,24],
      alignmentOptions: [
        {
          name: "left",
          className: "cx-alignment_left",
          title: '左对齐',
        },
        {
          name: "right",
          className: "cx-alignment_right",
          title: '右对齐',
        },
        {
          name: "center",
          className: "cx-alignment_center",
          title: '居中',
        },
        {
          name: "justify",
          className: "cx-alignment_justify",
          title: '两端对齐',
        },
      ],
      color: 'rgba(255, 69, 0, 0.68)',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c71586'
      ],
      dialogImageVisible: false,
      isActive: true,
      imageLink: '',
      listTypeOptions: [
        {
          name: "bulletedList",
          className: "cx-bulleted-list",
          title: '无序列表',
          icon: 'btn.svg'
        },
        {
          name: "numberedList",
          className: "cx-numbered-list",
          title: '有序列表',
          icon: 'btn.svg'
        }
      ],
      dialogAbstractVisible: false,
      abstractContent: '',

      replacedRoots: new Map(),
      dataFromRoots: new Map(),
      elementReplacer: new ElementReplacer(),

      // 配置
      thumbnail: null,
      pageImgLoading: false,
      tags: [], //话题
      categorys: [], // 分类
      categorysList:[],
      checkCategorysList: [],
      copyStatus: false,
      commentStatus: false,
      mainStatus: false,

      restaurants: [],
      state: '',
      publishTime: null,
      author: '',
      authorId: null,
      audioStatus: '1',
      
      categorysLoading: false,
      insertImageLoading: false,

      meta: {},
      generateVoiceBtnLoading: false
    }
  },
  components: {
    // ckeditor: CKEditor.component
  },
  created() {
    // document.querySelector('.el-main').style.backgroundColor= "#F2F4F5";
    let query = this.$route.query
    this.changeToolbar(query)
    if(query.post){
      this.currId = query.post
      if(query.isFilter == 1){
        this.isFilter = true
      }
      // if(!isMobile()){
      //   // 编辑时开放样式清除按钮
      //   this.toolbar[4].push({
      //     id: 'sourceCodeFilter',
      //     name: '清除样式',
      //     icon: 'filterCode.svg',
      //   })
      // }
      this.getArticleDetail(query.post)
    }
    this.initPageInfo()

  },
  mounted(){
    CaiXinEditor
      .create( {
          content: document.querySelector( '#content' ),
      }, {
          plugins: [ Essentials, Paragraph, Heading, FontSize, FontColor, Bold, Italic, Alignment, List, Image, Link,  HorizontalLine, ImageToolbar, ImageStyle, GeneralHtmlSupport], //RemoveFormat // ImageCaption, //, ImageResizeEditing, ImageResizeHandles
          image: {
              toolbar: [ 'toggleImageCaption', 'imageTextAlternative', '|', 'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText' ],
          },
          placeholder: {
            content: 'Type content here',
          },
          heading:{
            options: this.headingOptions
          },
          fontSize:{
            options: this.fontSizeOptions
          },
          link: {
            defaultProtocol: 'http://'
          },
          htmlSupport: {
            allow: [
                {
                    name: /.*/,
                    attributes: true,
                    classes: true,
                    styles: true
                }
            ],
            // disallow: [
            //   {
            //     // name: /[\s\S]+/,    // For every HTML feature,
            //     name: 'script',   
            //     attributes: {
            //       key: /^on.*$/ // disable 'on*' attributes, like 'onClick', 'onError' etc.
            //     }
            //   }
            // ]
          }
      } )
      .then( newEditor => {
        // document.querySelector( '#toolbar' ).appendChild( newEditor.ui.view.toolbar.element );
        window.CXEditor = newEditor;
        // console.log(Array.from( newEditor.ui.componentFactory.names() ))
        this.initToolBar()
        // 检查器
        // CKEditorInspector.attach( newEditor );
      } )
      .catch( err => {
          console.error( err.stack );
      } );
  },
  methods: {
    // changeToolbar(query){
    changeToolbar(){
      if(isMobile()){
        this.toolbar = [
          [ 
            { 
              id: 'undo',
              name: '撤销',
              icon: 'undo.svg',
            },
            { 
              id: 'redo',
              name: '重做',
              icon: 'redo.svg',
            },
            { 
              id: 'fontSize',
              name: '字号',
              icon: 'fontSize.svg',
            },
            { 
              id: 'italic',
              name: '斜体',
              icon: 'italic.svg',
            },
            { 
              id: 'bold',
              name: '加粗',
              icon: 'bold.svg',
            },
            { 
              id: 'image',
              name: '图像',
              icon: 'image.svg',
            },
            { 
              id: 'link',
              name: '链接',
              icon: 'link.svg',
            },
            { 
              id: 'abstract',
              name: '摘要',
              icon: 'abstract.svg',
            }
          ]
        ]

        // if(query.post){
          this.toolbar[0].push({
            id: 'sourceCodeFilter',
            name: '清除样式',
            icon: 'filterCode.svg',
          })
        // }
      }
    },
    async initPageInfo(){
      let info = await BlogApi.getUserlevel()
      // * 2 普通作者
      // * 10 管理员
      if(info.data == 10){
        this.isAdmin = true
      }
      if(info.attach.url){
        this.authorHomeUrl = info.attach.url
      }
    },
    initToolBar(){
      // 阻止鼠标点击窃取焦点
      this.initToolUI()
      // 初始化菜单栏
      this.initHeading()
      this.initFontSize()
      this.initFontColor()
      this.initAlignment()
      this.initImage()
      this.initLink()
      this.initList()
      // insertImage
    },
    initToolUI(){
      $('.el-dropdown').mousedown( evt => evt.preventDefault() );
      $(".tool-btn").hover(function(){
        if(!$(this).hasClass('tool-btn-disabled') && !$(this).hasClass('tool-btn-active')){
          $(this).css('color','#4990E1')
          let element = $(this).find('.tool-btn-icon')
          let imgUrl = element.css('background-image')
          let imgName = imgUrl.match(/img\/(\S*?)\./)[1]
          element.css('background-image', `url(${require(`../assets/img/toolbar/${imgName}_select.svg`)})`)
        }
      },function(){
        if(!$(this).hasClass('tool-btn-active')){
          $(this).css('color','#333333')
          let element = $(this).find('.tool-btn-icon')
          let imgUrl = element.css('background-image')
          let imgName = imgUrl.match(/img\/(\S*?)_select/)
          if(imgName && imgName.length > 1){
            element.css('background-image', `url(${require(`../assets/img/toolbar/${imgName[1]}.svg`)})`)
          }
        }
      });
    },
    initHeading(){
      const headingCommand = window.CXEditor.commands.get( 'heading' );
      headingCommand.on( 'change:value', ()=>{
        console.log(headingCommand.value)
        $('.el-dropdown-menu').find('.tool-heading-active').removeClass('tool-heading-active')
        if(headingCommand.value){
          $('.el-dropdown-menu').find(`.cx-heading_${headingCommand.value}`).addClass('tool-heading-active');
        }
      });
      headingCommand.on( 'change:isEnabled', ()=>{
        $('#heading').toggleClass( 'tool-btn-disabled', () => !headingCommand.isEnabled)
      });
    },
    initFontSize(){
      const fontSizeCommand = window.CXEditor.commands.get( 'fontSize' );
      fontSizeCommand.on( 'change:value', ()=>{
        console.log(fontSizeCommand.value)
        $('.el-dropdown-menu').find('.tool-fontsize-active').removeClass('tool-fontsize-active')
        if(fontSizeCommand.value){
          $('.el-dropdown-menu').find(`.cx-fontsize_${fontSizeCommand.value}`).addClass('tool-fontsize-active');
        }
      });
      fontSizeCommand.on( 'change:isEnabled', ()=>{
        $('#fontSize').toggleClass( 'tool-btn-disabled', () => !fontSizeCommand.isEnabled)
      });
    },
    initFontColor(){
      const fontColorCommand = window.CXEditor.commands.get( 'fontColor' );
      fontColorCommand.on( 'change:isEnabled', ()=>{
        $('#fontColor').toggleClass( 'tool-btn-disabled', () => !fontColorCommand.isEnabled)
      });
    },
    initAlignment(){
      const alignmentCommand = window.CXEditor.commands.get( 'alignment' );
      alignmentCommand.on( 'change:value', ()=>{
        console.log(alignmentCommand.value)
        $('.el-dropdown-menu').find('.tool-alignment-active').removeClass('tool-alignment-active')
        if(alignmentCommand.value){
          $('.el-dropdown-menu').find(`.cx-alignment_${alignmentCommand.value}`).addClass('tool-alignment-active');
        }
      });
      alignmentCommand.on( 'change:isEnabled', ()=>{
        $('#alignment').toggleClass( 'tool-btn-disabled', () => !alignmentCommand.isEnabled)
      });
    },
    initImage(){
      const imageCommand = window.CXEditor.commands.get( 'insertImage' );
      imageCommand.on( 'change:isEnabled', ()=>{
        $('#image').toggleClass( 'tool-btn-disabled', () => !imageCommand.isEnabled)
      });
    },
    initLink(){
      const linkCommand = window.CXEditor.commands.get( 'link' );
      linkCommand.on( 'change:value', ()=>{
        console.log(linkCommand.value)
      });
      linkCommand.on( 'change:isEnabled', ()=>{
        $('#link').toggleClass( 'tool-btn-disabled', () => !linkCommand.isEnabled)
      });
    },
    initList(){
      const bulletedListCommand = window.CXEditor.commands.get( 'bulletedList' );
      bulletedListCommand.on( 'change:value', ()=>{
        $('.el-dropdown-menu').find('.tool-list-active').removeClass('tool-list-active')
        if(bulletedListCommand.value){
          $('.el-dropdown-menu').find('.cx-bulleted-list').addClass('tool-list-active');
        }
      });
      const numberedListCommand = window.CXEditor.commands.get( 'numberedList' );
      numberedListCommand.on( 'change:value', ()=>{
        $('.el-dropdown-menu').find('.tool-list-active').removeClass('tool-list-active')
        if(numberedListCommand.value){
          $('.el-dropdown-menu').find('.cx-numbered-list').addClass('tool-list-active');
        }
      });
      bulletedListCommand.on( 'change:isEnabled', ()=>{
        $('#listType').toggleClass( 'tool-btn-disabled', () => !bulletedListCommand.isEnabled)
      });
    },
    clickBtn(){
      // 获取命令
      // const headingCommand = window.CXEditor.commands.get( 'heading' );
      // 执行命令
      // window.CXEditor.execute( 'heading', {value: 'heading1'} );
      
      // window.CXEditor.config.get( 'heading.options' )
      // 监听
      // headingCommand.on( 'change:value', ()=>{
      //   console.log(headingCommand.value)
      // });
      // headingCommand.on( 'change:isEnabled', ()=>{
      //   console.log(222)
      // });
      // window.CXEditor.execute( 'fontSize', {value: '24px'} );
      // window.CXEditor.execute( 'unlink');
      // window.CXEditor.execute( 'link');
      // window.CXEditor.execute( 'removeFormat');

      // window.CXEditor.execute( 'bulletedList');
      // console.log(window.CXEditor.commands.get( 'bulletedList' ));
      // console.log(window.CXEditor.commands.get( 'numberedList' ));
      

      // console.log(window.CXEditor.data)
      // console.log(window.CXEditor.getData({rootName:'content'}))
      // window.CXEditor.editing.view.focus();

      // BlogApi.addCategorys({name: '测试分类2'})
      // console.log(this.publishTime)

      // let externalData = external.replace(/<p[^>]*>/g, "<p>");
      // let externalData = external.replace(/<((?!IMG|A)[a-zA-Z]+)\s*[^><]*>/gi, "<$1>");
      // externalData = externalData.replace(/< img/g, "<img");
      // console.log(externalData)
      // content[ 'content' ] = externalData
      // window.CXEditor.data.set( content, { batchType: 'default' } );
    },
    selectHeadOption(option){
      console.log(option)
      if(option){
        window.CXEditor.execute( 'heading', {value: option} );
        window.CXEditor.editing.view.focus();
      }
    },
    selectFontSizeOption(option){
      console.log(option)
      if(option){
        window.CXEditor.execute( 'fontSize', {value: `${option}px`} );
        window.CXEditor.editing.view.focus();
      }
    },
    selectAlignmentOption(option){
      console.log(option)
      if(option){
        window.CXEditor.execute( 'alignment', {value: option} );
        window.CXEditor.editing.view.focus();
      }
    },
    clickFontColor(e){
      if(e.isTrusted){
        console.log(111)
        // 初始化颜色选择器
        $('.el-color-dropdown__main-wrapper').hide()
        $('.el-color-alpha-slider').hide()
        $('.el-color-dropdown__value').hide()
        $('.el-color-predefine__color-selector').mousedown( evt => evt.preventDefault() );
        // 展示颜色选择器
        $('.el-color-picker__trigger').click()
      }
    },
    selectFontColor(color){
      console.log(color)
      window.CXEditor.execute( 'fontColor', {value: color} );
      window.CXEditor.editing.view.focus();
    },
    selecListOption(option){
      console.log(option)
      if(option){
        window.CXEditor.execute( option);
        window.CXEditor.editing.view.focus();
      }
    },
    handleClickToolBtn(id){
      console.log(id)
      if($(`#${id}`).hasClass('tool-btn-disabled')){
        return
      }
      if(id == 'link'){
        this.handleClickLink()
      }
      if(id == 'image'){
        this.dialogImageVisible = true
        // window.CXEditor.execute( 'insertImage', { source: 'https://file.caixin.com/images/noavatar.jpg' } );
      }
      if(id == 'abstract'){
        console.log(this.abstractContent)
        if(this.abstractContent == ''){
          let oldData = window.CXEditor.getData({rootName:'content'})
          let container = `<div>${oldData}</div>`
          if($(container).find("p").length > 0){
            this.abstractContent = $(container).find("p")[0].innerText
          }
        }
        this.dialogAbstractVisible = true
      }
      if(id == 'catalog'){
        let oldData = window.CXEditor.getData({rootName:'content'})
        let container = `<div>${oldData}</div>`
        let aString = ''
        if($(container).find('#main-toc')[0]){
          container = container.replace(this.nodeToString($(container).find('#main-toc')[0]),'')
        }
        
        $(container).find(":header").each((x, item)=>{
          if($(item).prop('nodeName') == 'H4'){
            return true;
          }
          let oldItem = this.nodeToString(item)
          $(item).attr('id',$(item).html());
          container = container.replace(oldItem, this.nodeToString(item))
          let marginLeft = 0
          switch ($(item).prop('nodeName')) {
            case 'H1':
              marginLeft = 10
              break;
            case 'H2':
              marginLeft = 20
              break;
            case 'H3':
              marginLeft = 30
              break;
            // case 'H4':
            //   marginLeft = 40
              // break;
          }
          aString += `<p style="margin-left:${marginLeft}px"><a target="_self" style='color: #6795B5;text-decoration: none;' href="#${$(item).html()}">${$(item).html()}</a></p>`
        })

        let data = {}
        data[ 'content' ] = `<div id="main-toc"><p><strong>目录</strong></p>${aString}<hr></div>${$(container).html()}`
        window.CXEditor.data.set( data, { batchType: 'default' } );
        
      }
      if(id == 'sourceCode'){
        if($('#sourceCode').hasClass('tool-btn-active')){
          this._hideSourceEditing()
          this._enableCommands()
          $('#catalog').removeClass('tool-btn-disabled')
        }else{
          this._showSourceEditing()
          this._disableCommands()
          $('#catalog').addClass('tool-btn-disabled')
          $('#sourceCode').css('color','#4990E1')
          $('#sourceCode').find('.tool-btn-icon').css('background-image', `url(${require('../assets/img/toolbar/sourceCode_select.svg')})`)
        }
        $('#sourceCode').toggleClass( 'tool-btn-active');
        
      }
      if(id == 'sourceCodeFilter'){
        let query = this.$route.query
        if(query.post){
          this.$router.push({path:this.$route.path,query:{...this.$route.query, isFilter:1}})
          location.reload()
        }else{
          let articleContent = window.CXEditor.getData({rootName:'content'}).replace(/<((?!IMG|A)[a-zA-Z]+)\s*[^><]*>/gi, "<$1>")
          .replace(/<img.+?src\s*=\s*"(.+?)".+?>/gi, "<img src=$1>")
          .replace(/<a.+?href\s*=\s*"(.+?)"\s*[^><]*>/gi, "<a href=$1>")
          let content = {}
          content[ 'content' ] = articleContent
          window.CXEditor.data.set( content, { batchType: 'default' } );
        }
      }

      
    },
    nodeToString ( node ) {  
      var tmpNode = document.createElement( "div" ); 
      tmpNode.appendChild( node.cloneNode( true ) );  
      var str = tmpNode.innerHTML;  
      tmpNode = node = null;  
      return str;  
    },
    handleClickLink(){
      // var evt = document.createEvent("UIEvents");
      // evt.keyCode = 75;
      // evt.metaKey = true
      // // evt.ctrlKey = true
      // evt.initEvent("keydown", true, true);
      // document.getElementById('content').dispatchEvent(evt);
      this.$prompt('请输入链接', '', {
        confirmButtonText: '确定',
        // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        console.log(value)
        window.CXEditor.execute( 'link', value);
        window.CXEditor.editing.view.focus();
      }).catch(() => {
        window.CXEditor.editing.view.focus();    
      });
    },
    async handleFileChange(file) {
      if (file.size / 1024 / 1024 > 4.88) {
        this.$refs.contentUploadImg.clearFiles()
        this.$message.error('请上传小于5M文件')
        return
      }
      this.insertImageLoading = true
      var fileData = new FormData()
      fileData.append('file', file.raw)
      let info = await BlogApi.uploadFile(fileData)
      let imgAdress = info.data
      if(imgAdress.indexOf('http') == -1){
        imgAdress = environment.apiBlogEditorUrl + info.data
      }
      window.CXEditor.execute( 'insertImage', { source: imgAdress } );
      this.insertImageLoading = false
      this.dialogImageVisible = false
    },
    async handlePageImgChange(file){
      this.pageImgLoading = true
      var fileData = new FormData()
      fileData.append('file', file.raw)
      let info = await BlogApi.uploadFile(fileData)
      let imgAdress = info.data
      if(imgAdress.indexOf('http') == -1){
        imgAdress = environment.apiBlogEditorUrl + info.data
      }
      this.thumbnail = imgAdress
      this.pageImgLoading = false
      $('.page-upload-img .image').css(
        {
        'background-image':`url(${this.thumbnail})`,
        'background-size': '100% 100%'
        })
    },
    handleSwitchTab(){
      this.isActive = !this.isActive
    },
    insertImageLink(){
      if(this.imageLink && this.imageLink != ''){
        window.CXEditor.execute( 'insertImage', { source: this.imageLink } );
        this.dialogImageVisible = false
        this.imageLink = ''
      }
    },
    cancelAbstract(){
      this.dialogAbstractVisible = false
    },
    createAbstract(){
      console.log(this.abstractContent)
      if(this.abstractContent == ''){
        this.$message.error('请输入摘要')
        return
      }
      this.dialogAbstractVisible = false
    },
    _showSourceEditing() {
      const editor = window.CXEditor;
      const editingView = editor.editing.view;
      const model = editor.model;

      model.change( writer => {
        writer.setSelection( null );
        writer.removeSelectionAttribute( model.document.selection.getAttributeKeys() );
      } );

      for ( const [ rootName, domRootElement ] of editingView.domRoots ) {
        const data = this.formatSource( editor.data.get( { rootName } ) );

        const domSourceEditingElementTextarea = createElement( domRootElement.ownerDocument, 'textarea', { rows: '1' } );

        const domSourceEditingElementWrapper = createElement( domRootElement.ownerDocument, 'div', {
          class: 'ck-source-editing-area',
          'data-value': data
        }, [ domSourceEditingElementTextarea ] );

        domSourceEditingElementTextarea.value = data;

        // Setting a value to textarea moves the input cursor to the end. We want the selection at the beginning.
        domSourceEditingElementTextarea.setSelectionRange( 0, 0 );

        // Bind the textarea's value to the wrapper's `data-value` property. Each change of the textarea's value updates the
        // wrapper's `data-value` property.
        domSourceEditingElementTextarea.addEventListener( 'input', () => {
          domSourceEditingElementWrapper.dataset.value = domSourceEditingElementTextarea.value;
        } );

        editingView.change( writer => {
          const viewRoot = editingView.document.getRoot( rootName );

          writer.addClass( 'ck-hidden', viewRoot );
        } );

        this.replacedRoots.set( rootName, domSourceEditingElementWrapper );

        this.elementReplacer.replace( domRootElement, domSourceEditingElementWrapper );

        this.dataFromRoots.set( rootName, data );
      }

      this._focusSourceEditing();
    },
    formatSource( input ) {
      if ( !this.isHtml( input ) ) {
        return input;
      }

      return formatHtml( input );
    },
    isHtml( input ) {
      return input.startsWith( '<' );
    },
    _focusSourceEditing() {
      const [ domSourceEditingElementWrapper ] = this.replacedRoots.values();

      const textarea = domSourceEditingElementWrapper.querySelector( 'textarea' );

      textarea.focus();
    },
    _hideSourceEditing() {
      const editor = window.CXEditor;
      const editingView = editor.editing.view;

      const data = {};

      for ( const [ rootName, domSourceEditingElementWrapper ] of this.replacedRoots ) {
        const oldData = this.dataFromRoots.get( rootName );
        const newData = domSourceEditingElementWrapper.dataset.value;
        // Do not set the data unless some changes have been made in the meantime.
        // This prevents empty undo steps after switching to the normal editor.
        if ( oldData !== newData ) {
          data[ rootName ] = newData;
        }

        editingView.change( writer => {
          const viewRoot = editingView.document.getRoot( rootName );

          writer.removeClass( 'ck-hidden', viewRoot );
        } );
      }

      this.elementReplacer.restore();

      this.replacedRoots.clear();

      this.dataFromRoots.clear();

      if ( Object.keys( data ).length ) {
        editor.data.set( data, { batchType: 'default' } );
      }

      editor.editing.view.focus();
    },
    /**
     * Disables all commands.
     *
     * @private
     */
    _disableCommands() {
      const editor = window.CXEditor;

      for ( const command of editor.commands.commands() ) {
        command.forceDisabled( COMMAND_FORCE_DISABLE_ID );
      }
    },

    /**
     * Clears forced disable for all commands, that was previously set through {@link #_disableCommands}.
     *
     * @private
     */
    _enableCommands() {
      const editor = window.CXEditor;

      for ( const command of editor.commands.commands() ) {
        command.clearForceDisabled( COMMAND_FORCE_DISABLE_ID );
      }
    },
    handleClose(tag){
      this.tags.splice(this.tags.indexOf(tag), 1);
    },
    handleCloseCategorys(tag){
      this.categorys.splice(this.categorys.indexOf(tag), 1);
      this.checkCategorysList.splice(this.checkCategorysList.indexOf(tag.id),1)
    },
    async querySearchAsync(queryString, cb) {
      let tags = await BlogApi.searchTags(queryString)
      // let tagList = []
      // if(tags.data){
      //   Object.keys(tags.data).forEach(item =>{
      //     tagList = tagList.concat(tags.data[item])
      //   })
      // }
      let suggestTag = []
      tags.data && tags.data.forEach(item =>{
        suggestTag.push({
          value: item.name,
          id: item.tagId,
        })
      })
      console.log(suggestTag)
      cb(suggestTag)
    },
    handleSelect(item) {
      console.log(item);
      this.tags.push({
        name: item.value,
        tagId: item.id,
      })
      this.state = ''
      $('#header').click()
    },
    handleChangeCategorys(value){
      if(this.categorys.length > 0){
        // 删除选中分类（个人分类改为单选）
        this.checkCategorysList.splice(this.checkCategorysList.indexOf(this.categorys[0].cateId),1)
        // value.splice(value.indexOf(this.categorys[0].cateId), 1)
      }
      let tags = []
      this.categorysList.forEach(item =>{
        if(value.includes(item.id)){
          tags.push({
            name: item.name,
            cateId: item.id
          })
        }
      })
      this.categorys = tags
    },
    async querySearchAsyncAuthor(queryString, cb) {
      console.log(queryString)
      let info = await BlogApi.searchAuthor({
        keyword: queryString,
        page: 1,
        size: 100
      })
      console.log(info)
      let arr = []
      if(info.data){
        info.data.forEach(item =>{
          arr.push({
            id: item.id,
            value: item.username,
          })
        })
      }
      cb(arr)
    },
    handleSelectAuthor(item) {
      console.log(item);
      this.authorId = item.id
      this.author = item.value
      $('#header').click()
      this.categorys = []
    },
    async addCategorys(){
      this.categorysLoading = true
      let categorys = null
      categorys = await BlogApi.searchCategorys({userId: this.authorId })
      this.categorysList = categorys.data
      this.categorysLoading = false
    },
    setUpCategotys(){
      // window.open(`${this.authorHomeUrl}/wp-admin/edit-user-category.php`)
      window.open(`${environment.deployUrl}/classification.html`)
    },
    async getArticleDetail(articleId){
      let info = await BlogApi.getContent({id: articleId})
      if(info.code == 403){
        this.currId = null
        return
      }
      console.log(info)
      let data = info.data
      let articleContent = data.content
      // 正文内容
      // if(this.isFilter && data.content.indexOf('article-content-falg') == -1){
      if(this.isFilter){
        // 需要过滤多余属性及样式
        articleContent = data.content.replace(/<((?!IMG|A)[a-zA-Z]+)\s*[^><]*>/gi, "<$1>")
          .replace(/<img.+?src\s*=\s*"(.+?)".+?>/gi, "<img src=$1>")
          .replace(/<a.+?href\s*=\s*"(.+?)"\s*[^><]*>/gi, "<a href=$1>")
      }
      let content = {}
      content[ 'content' ] = articleContent
      window.CXEditor.data.set( content, { batchType: 'default' } );

      this.categorys = data.cateIds ? data.cateIds : []
      let arr = []
      data.cateIds && data.cateIds.forEach(item =>{
        arr.push(item.cateId)
      })
      this.checkCategorysList = arr

      this.title = data.title
      this.abstractContent = data.brief
      this.tags = data.tags ? data.tags : []
      this.publishTime = data.publishTime
      this.authorId = data.userId
      this.author = data.displayName

      this.copyStatus = data.copyStatus == 'open' ? false : true
      this.commentStatus = data.commentStatus == 'open' ? false : true
      this.thumbnail = data.thumbnail
      $('.page-upload-img .image').css({
        'background-image':`url(${this.thumbnail})`,
        'background-size': '100% 100%'
      })
      this.meta = data.meta
      this.audioStatus = data.meta.ai_speech == 'true' ? '2': '1'
      this.mainStatus = (data.meta.show_index == 0 || data.meta.show_index == null) ? false : true
      // this.mainStatus = !data.meta.show_index ? false : true
    },  
    async saveContent(type, force = false){

      if(this.title.trim().length == 0){
        this.$message.error('请输入标题')
        return 
      }
      let articleContent = window.CXEditor.getData({rootName:'content'})
      if(articleContent.trim().length == 0){
        this.$message.error('请输入正文')
        return 
      }
      
      // if(articleContent.indexOf('article-content-falg') == -1){
      //   articleContent = `<div id="article-content-falg">${articleContent}</div>`
      // }
      // if(this.abstractContent == ''){
      //   let oldData = window.CXEditor.getData({rootName:'content'})
      //   let container = `<div>${oldData}</div>`
      //   if($(container).find("p").length > 0){
      //     this.abstractContent = $(container).find("p")[0].innerHTML
      //   }
      // }
      
      let param = {
        id: this.currId,
        title: this.title,
        brief: this.abstractContent,
        content: articleContent,
        cateIds: this.categorys,
        tags: this.tags,
        publishTime: null,
        userId: this.authorId,
        postStatus: type,
        copyStatus: this.copyStatus ? 'closed' : 'open',
        commentStatus: this.commentStatus ? 'closed' : 'open',
        thumbnail: this.thumbnail,
        meta: this.meta,
      }
      if(this.isAdmin){
        param.publishTime = this.publishTime

        param.meta = {
          ...this.meta,
          ai_speech: this.audioStatus == 2 ? 'true' : 'false',
          show_index: this.mainStatus ? '1' : '0'
        }
      }
      console.log(param)
      this.$loading();
      let info = {}
      if(force){
        info = await BlogApi.forceSaveContent(param)
      }else{
        info = await BlogApi.saveContent(param)
      }
      this.$loading().close();
      let text = this.currId ? `文章ID ${this.currId} ` : ''
      if(info.code == 0){
        if(info.data){
          this.$message.success('操作成功')
          this.meta = info.data.meta
          if(!this.currId){
            this.currId = info.data.id
            this.$router.push({path:this.$route.path,query:{...this.$route.query, post:this.currId}})
          }
        }
      }else if(info.code == 431){
        this.$alert(`${text}包含敏感词: ${info.attach.forbiddenWords},请修改后重新发布`, '包含敏感词', {
          showCancelButton: true,
          confirmButtonText: '确定',
          callback: action => {
            // confirm/cancel
            console.log(action)
            if(this.abstractContent.indexOf(info.attach.forbiddenWords) != -1){
              this.abstractContent = ''
            }
          }
        });
      }else if(info.code == 430){
        this.$alert(`${text}包含敏感词: ${info.attach.forbiddenWords},请确认是否发布。`, '包含敏感词', {
          showCancelButton: true,
          confirmButtonText: '确定发布',
          callback: action => {
            // confirm/cancel
            if(this.abstractContent.indexOf(info.attach.forbiddenWords) != -1){
              this.abstractContent = ''
            }
            if(action == 'confirm'){
              this.saveContent(type, true)
            }
          }
        });
      }else{
        let msg = info.code == 500 ? '系统错误，请联系管理员或稍后再试。' : decodeURIComponent(info.msg)
        this.$alert(`${msg}`, 'This is an error message', {
          type: 'error',
          confirmButtonText: '确定',
          callback: () => {
            
          }
        });
      }
      
    },
    async generateVoice(){
      this.generateVoiceBtnLoading = true
      let info = await BlogApi.generateVoice({id: this.currId})
      this.generateVoiceBtnLoading = false
      if(info.data){
        this.$message.success('操作成功')
        this.meta = info.data.meta
      }
    },
    async jumpAudio(name){
      // ai_speech_status  "pending"/"done"
      if(this.meta.ai_speech_status == 'done'){
        window.open(this.meta[name])
        return
      }
      // if(!this.currId){
      //   this.$message.error('暂无文章信息，请点击重新生成语音')
      //   return
      // }
      // let info = await BlogApi.getMetaInfo({
      //   id: this.currId,
      //   key: 'ai_speech_status'
      // })
      // if(info.data == 'done'){
      //   let audioInfo = await BlogApi.getMetaInfo({
      //     id: this.currId,
      //     key: name
      //   })
      //   window.open(audioInfo.data)
      // }else{
      //   this.$message.error('语音生成中，请稍后再试')
      // }
    }
  },
}
</script>
<style lang="less" scoped>
  .cx-editor{
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F2F4F5;
    padding: 0 0 100px 0;
    // transform:translate(0,0);
    /deep/ h1{
      font-size: 1.8em;
    }
    #header{
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1999;
      background-color: #27233B;
      padding: 0 10px 0 10px;
      box-sizing: border-box;
      // img{
        // width: 200px;
      // }
      .el-button{
        width: 100px;
        height: 30px;
        padding: 0;
      }
    }
    #toolbar{
      width: 70%;
      // height: 60px;
      position: fixed;
      // top: 60px;
      left: 20%;
      z-index: 1999;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #ACADAD;
      background-color: #F2F4F5;
      .tool-group{
        position: relative;
        float: left;
        // margin: 1px 2px 6px 0;
        padding: 0 8px;
        .tool-btn{
          display: inline-block;
          padding: 0 8px;
          margin: 0 5px;
          // height: 52px;
          outline: 0;
          cursor: pointer;
          text-align: center;
          border: 0;
          position: relative;
          color: #333333;
          .tool-btn-icon{
            cursor: inherit;
            background-repeat: no-repeat;
            width: 28px;
            height: 28px;
            display: inline-block;
            margin-top: 4px;
          }
          .tool-btn-name{
            display: block;
            font-size: 12px;
            text-align: center;
            cursor: pointer;
            line-height: 10px;
          }
          .el-color-picker {
            position: absolute;
            top: 20px;
            left: 0;
            opacity: 0;
            z-index: -1;
          }
        }
        .tool-btn-disabled{
          opacity: .4;
        }
        .tool-btn:hover,
        .tool-btn-active{
          background: #f0f0f5;
        }
      }
      .tool-group::after {
        content: '';
        position: absolute;
        height: 18px;
        width: 1px;
        background-color: #dbdbdb;
        top: 17px;
        right: 0;
      }
    }
    #title{
      width: 70%;
      margin-top: 130px;
      padding: 40px 20px 20px 20px;
      background-color: white;
      textarea{
        width: 100%;
        border: none;
        border-bottom: 1px solid #ACADAD;
        font-size: 20px;
        font-weight: 700;
        outline: none;
      }
    }
    @media screen and (max-width: 500px) {
        #title {
          margin-top: 130px;
        }
    }
    #content{
      width: 70%;
      background-color: white;
      padding: 0 20px;
      outline: none;
      border: none;
      box-shadow: none;
      min-height: 700px;
    }
    /deep/ .ck-source-editing-area{
      width: 70%;
      background-color: white;
      padding: 0 20px;
      textarea{
        width: 100%;
        border: none;
        outline: none;
        resize: none;
        min-height: 700px;
      }
    }
    .config-view{
      width: 70%;
      margin-top: 20px;
      background-color: white;
      padding: 20px 20px;
      .left-title{
        display: inline-block;
        width: 80px;
        text-align: left;
        margin-left: 20px;
      }
      .picture{
        .page-upload-img{
          display: inline-block;
          vertical-align: top;
          /deep/ .el-upload-list{
            display: none;
          }
        }
        .image{
          display: inline-block;
          width: 200px;
          height: 100px;
          border: 1px dashed #D8D8D8;
          border-radius: 10px;
          color: #D8D8D8;
          font-size: 28px;
          line-height: 100px;
        }
      }
      .category,
      .tags{
        margin-top: 25px;
        .el-tag + .el-tag {
          margin-left: 20px;
        }
        .add-tag-btn::before{
          content: "＋";
          margin-right: 4px;
        }
        .add-tag-btn{
          display: inline-block;
          width: 120px;
          height: 30px;
          border: 1px dashed #D8D8D8;
          border-radius: 6px;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          color: #666666;
          margin-left: 20px;
        }
      }
      .author,
      .audio,
      .audio-adress,
      .other{
        margin-top: 25px;
        .right-block{
          display: inline-block;
          vertical-align: top;
          span{
            display: inline-block;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
  .tool-alignment-active,
  .tool-fontsize-active,
  .tool-heading-active,
  .tool-list-active{
    background-color: #ecf5ff;
    // color: #66b1ff;
  }
  .el-dropdown-menu__item:hover{
    color: #606266;
  }
  /deep/ .cx-alignment_left_icon,
  /deep/ .cx-alignment_right_icon,
  /deep/ .cx-alignment_center_icon,
  /deep/ .cx-alignment_justify_icon,
  /deep/ .cx-bulleted-list_icon,
  /deep/ .cx-numbered-list_icon
  {
    display: inline-block;
    background: url('../assets/img/toolbar/left.svg') no-repeat;
    background-size: 100% 100%;
    vertical-align: -3px;
    width: 24px; height: 16px;
    margin: 0 0 0 -15px;
  }
  /deep/ .cx-alignment_right_icon{
    background: url('../assets/img/toolbar/right.svg') no-repeat;
    background-size: 100% 100%;
  }
  /deep/ .cx-alignment_center_icon{
    background: url('../assets/img/toolbar/center.svg') no-repeat;
    background-size: 100% 100%;
  }
  /deep/ .cx-alignment_justify_icon{
    background: url('../assets/img/toolbar/justify.svg') no-repeat;
    background-size: 100% 100%;
  }
  /deep/ .cx-bulleted-list_icon{
    background: url('../assets/img/toolbar/bulleted-list.svg') no-repeat;
    background-size: 100% 100%;
  }
  /deep/ .cx-numbered-list_icon{
    background: url('../assets/img/toolbar/numbered-list.svg') no-repeat;
    background-size: 100% 100%;
  }
  
  /deep/ .el-dialog{
    width: 500px;
    .el-dialog__header{
      padding: 0;
    }
    .el-dialog__body{
      padding: 20px 20px 0 20px;
    }
    .el-upload-list{
      display: none;
    }
    .header-tab{
      margin: 0;
      font-size: 14px;
      a:first-child{
        margin-right: 20px;
      }
      .active{
        color: #66b1ff;
      }
    }
    .content-div,
    .abstract-content-div{
      height: 130px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .input-link-div{
        width: 100%;
        .image-link{
          width: 70%;
          margin-right: 10px;
        }
      }
    }
    .abstract-content-div{
      height: 300px;
      .abstract-textarea{
        .el-textarea__inner{
          height: 200px;
          resize: none;
        }
      }
      .abstract-footer{
        margin-top: 20px;
      }
    }
    
  }
  .el-popover{
    .el-checkbox{
      display: block;
    }
    // /deep/ .el-input__inner{
    //   border: none;
    //   border-radius: 0;
    //   border-bottom: 1px solid #DCDFE6;
    // }
  }

</style>